import { useState, useEffect } from 'react';
import {
    Container,
    Typography,
    Box,
    Paper,
    Button,
    Fade,
    useTheme,
    Chip,
    Stack,
} from '@mui/material';
import { CreditCard, Shield } from 'lucide-react';
import SimpleBackdrop from '../../components/Loading/SimpleBackdrop';
import { AlertInfo } from '../../components/Alerts/Alert';
import { formatDate } from '../../utilities/date';
import { api, apiUrl } from '../../services/api';

import PricingPage from '../RenewPlan/PricingPage';
import moment from 'moment';

export default function Bloqueio() {
    const theme = useTheme();
    const [paymentPlan, setPaymentPlan] = useState(false);
    const [openLoad, setOpenLoad] = useState(false);
    const [final_licence, setFinalLicence] = useState(formatDate(new Date(), "br"));
    const [nome_plano_licence, setNomePlanoLicence] = useState("Não informado");

    async function loadData() {
        setOpenLoad(true);
        try {
            const response = await api.get('/licence');
            console.log(response)
            if (response && response.data) {
                if (response.data.error) return AlertInfo({ icon: 'error', title: response.data.msg });
                if (response.data.id_licence) {
                    setFinalLicence(response.data.final_licence);
                    setNomePlanoLicence(response.data.nome_plano_licence);
                }

            }
        } catch (error) {
            console.log(error)
            AlertInfo({ icon: 'error', title: 'Falha na conexão' })
        }
        setOpenLoad(false);
    }

    useEffect(() => {
        loadData();
    }, []);

    if (paymentPlan) {
        return (
            <Box
                sx={{
                    minHeight: '100vh',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: 2,
                    position: 'relative',
                    overflow: 'hidden',
                }}
            >
                <SimpleBackdrop open={openLoad} />

                <Container sx={{ position: 'relative', zIndex: 1 }}>
                    <Fade in={true} timeout={1000}>
                        <Paper
                            elevation={24}
                            sx={{
                                padding: 2,
                                textAlign: 'center',
                                borderRadius: 3,
                                backdropFilter: 'blur(20px)',
                                position: 'relative',
                                overflow: 'hidden',
                            }}
                        >

                            <Box>
                                <img src={`${apiUrl}/img/logo-sysprojud`} height={130} alt="Logo SysProJud"></img>
                            </Box>
                            <PricingPage />
                        </Paper>
                    </Fade>
                </Container>
            </Box>
        );
    }

    return (
        <Box
            sx={{
                minHeight: '100vh',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: 2,
                position: 'relative',
                overflow: 'hidden',
            }}
        >
            <SimpleBackdrop open={openLoad} />

            <Container maxWidth="md" sx={{ position: 'relative', zIndex: 1 }}>
                <Fade in={true} timeout={1000}>
                    <Paper
                        elevation={24}
                        sx={{
                            padding: 2,
                            textAlign: 'center',
                            borderRadius: 3,
                            backdropFilter: 'blur(20px)',
                            position: 'relative',
                            overflow: 'hidden',
                        }}
                    >

                        <Box>
                            <img src={`${apiUrl}/img/logo-sysprojud`} height={130} alt="Logo SysProJud"></img>

                            <Typography
                                variant="h3"
                                component="h1"
                            >
                                Sistema Bloqueado
                            </Typography>
                        </Box>

                        <Box
                            sx={{
                                marginLeft: { xs: 1, md: 20 },
                                marginRight: { xs: 1, md: 20 },
                            }}
                        >
                            <Box sx={{ textAlign: 'left' }}>
                                <Typography variant="h6" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                    <Shield size={20} />
                                    Detalhes da Licença
                                </Typography>

                                <Stack spacing={2}>
                                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                        <Typography variant="body2">Plano:</Typography>
                                        <Typography variant="body2" sx={{ fontWeight: 600 }}>{nome_plano_licence}</Typography>
                                    </Box>
                                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                        <Typography variant="body2">Data de Expiração:</Typography>
                                        <Typography variant="body2" sx={{ fontWeight: 600, color: theme.palette.error.main }}>{moment(final_licence).format("DD/MM/YYYY")}</Typography>
                                    </Box>
                                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                        <Typography variant="body2">Status:</Typography>
                                        <Chip label="EXPIRADA" size="small" color="error" />
                                    </Box>
                                </Stack>
                            </Box>
                        </Box>

                        <Typography
                            variant="h5"
                            sx={{
                                color: theme.palette.secondary.main,
                                fontWeight: 600,
                            }}
                        >
                            Renovar Licença
                        </Typography>

                        <Typography
                            variant="body1"
                            sx={{ mb: 2, maxWidth: '500px', mx: 'auto' }}
                        >
                            Para continuar usando o sistema, é necessário renovar sua licença.
                            Clique no botão abaixo para processar o pagamento e reativar seu acesso imediatamente.
                        </Typography>

                        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} justifyContent="center">
                            <Button
                                variant="contained"
                                size="large"
                                startIcon={<CreditCard size={20} />}
                                onClick={() => setPaymentPlan(true)}
                                sx={{
                                    background: 'linear-gradient(135deg, #ff6b35, #ffd23f)',
                                    color: '#000',
                                    fontWeight: 'bold',
                                    fontSize: '1.1rem',
                                    px: 4,
                                    py: 1.5,
                                    borderRadius: 2,
                                    textTransform: 'none',
                                    boxShadow: '0 4px 20px rgba(255, 107, 53, 0.4)',
                                    transition: 'all 0.3s ease',
                                    '&:hover': {
                                        background: 'linear-gradient(135deg, #ffd23f, #ff6b35)',
                                        transform: 'translateY(-2px)',
                                        boxShadow: '0 6px 25px rgba(255, 107, 53, 0.6)',
                                    },
                                }}
                            >
                                Renovar Agora
                            </Button>
                        </Stack>

                        <Box sx={{ mt: 2, pt: 3, borderTop: '1px solid rgba(255, 255, 255, 0.1)' }}>
                            <Typography variant="body2" sx={{ fontSize: '0.9rem' }}>
                                Precisa de ajuda? Entre em contato com nosso suporte técnico
                            </Typography>
                            <Typography variant="body2" sx={{ fontWeight: 600, mt: 0.5 }}>
                                suporte@sysprojud.com | (91) 9999-9999
                            </Typography>
                        </Box>
                    </Paper>
                </Fade>
            </Container>
        </Box>
    );
}